import { Truck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { SimpleMultiSelect, type SelectOption } from '@/shared/ui/filters';

interface VehicleCategoryFilterProps {
  options: SelectOption[];
  value: string[];
  onChange: (value: string[]) => void;
  className?: string;
  isLoading?: boolean;
}

export function VehicleCategoryFilter({
  options,
  value,
  onChange,
  className = 'w-full md:w-80'
}: VehicleCategoryFilterProps) {
  const { t } = useTranslation();

  return (
    <div className="min-w-0 space-y-2">
      <Label className="min-w-0 text-sm font-medium">
        <Truck className="h-4 w-4 shrink-0" />
        <span className="truncate">{t('welcome.vehicle.category.filter.label')}</span>
      </Label>
      <SimpleMultiSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder={t('dashboard.vehicleCategory.placeholder')}
        className={className}
      />
    </div>
  );
}
